<ng-template #template  tabindex="-1">
  <div class="modal-header">
    <h5 class="modal-title">Modifica Viaggio </h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalDismiss();modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div style="margin-bottom: 10px; text-align:center;">
      <b >viaggio # {{travel_to_update.trv_id}} ({{travel_status_description}}) - {{travel_to_update.vhc_plate}} </b>
    </div>
    <!-- KM -->
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" >Km iniziali</span>
      </div>
      <input type="number" min="1" max="999999" class="form-control"
             [(ngModel)]="travel_to_update.trv_start_kilometers" [disabled]="input_disabled_mapping.trv_start_kilometers" (ngModelChange)="checkForUpdate()"
             aria-label="Kilometri iniziali" aria-describedby="basic-addon1">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" >Km finali </span>
      </div>
      <input type="number" min="1" max="999999" class="form-control"
             [(ngModel)]="travel_to_update.trv_end_kilometers" [disabled]="input_disabled_mapping.trv_end_kilometers" (ngModelChange)="checkForUpdate()"
             aria-label="Kilometri finali" aria-describedby="basic-addon1">
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text" id="creato">Creato il</span>
      </div>
      <input type="text" class="form-control"
             [ngModel]="travel_to_update.trv_created_at | date:'dd/MM/yy HH:mm'"
             aria-label="creato" aria-describedby="basic-addon1" disabled>
    </div>


    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text" id="richiestoDa">Richiesto dal</span>
      </div>
      <input type="text" class="form-control"
             [ngModel]="travel_to_update.trv_required_from | date:'dd/MM/yy HH:mm'"
             aria-label="Richiesto da" aria-describedby="basic-addon1" disabled>
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text" id="richiestoA">Richiesto al</span>
      </div>
      <input type="text" class="form-control"
             [ngModel]="travel_to_update.trv_required_to | date:'dd/MM/yy HH:mm'"
             aria-label="Richiesto da" aria-describedby="basic-addon1" disabled>
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text" id="handled">Approvato il</span>
      </div>
      <input type="text" class="form-control"
             [ngModel]="travel_to_update.trv_handled_at | date:'dd/MM/yy HH:mm'"
             aria-label="approvato" aria-describedby="basic-addon1" disabled>
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text" id="started">Iniziato il</span>
      </div>
      <input type="text" class="form-control"
             [ngModel]="travel_to_update.trv_started_at | date:'dd/MM/yy HH:mm'"
             aria-label="iniziato" aria-describedby="basic-addon1" disabled>
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <span class="input-group-text">Concluso il: </span>
      </div>

      <input type="text"
             class="form-control"
             style="height: auto;"
             #dp="bsDatepicker"
             bsDatepicker
             [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
             [(bsValue)]="travel_to_update.trv_ended_at" [disabled]="input_disabled_mapping.trv_ended_at" (bsValueChange)="checkForUpdate()">
      <timepicker [(ngModel)]="travel_to_update.trv_ended_at" [showMeridian]="false"
                  [disabled]="input_disabled_mapping.trv_ended_at"></timepicker>
    </div>

    <div  class="input-group mb-1">
      Liv carburante:
      <rating [max]="5" [(ngModel)]="travel_to_update.trv_fuel_level" [customTemplate]="tt" [disabled]="input_disabled_mapping.trv_fuel_level" (ngModelChange)="checkForUpdate()"></rating>

      <ng-template #tt let-i="index" let-v="value">
        <button class="btn btn-{{i < v ? 'alert' : 'default'}}" [disabled]="input_disabled_mapping.trv_fuel_level" >
          {{i == 0 ? '&#48;' : ''}}
          {{i == 1 ? '&#188;' : ''}}
          {{i == 2 ? '&#189;' : ''}}
          {{i == 3 ? '&#190;' : ''}}
          {{i == 4 ? '&#49;' : ''}}
        </button>
      </ng-template>
    </div>

    <hr>

    <div  class="input-group mb-1" style="justify-content: center;">
      <button class="btn btn-success btn-sm m-2" [disabled]="button_disabled_status_mapping.btn_chiudi" (click)="onClick_btn_chiudi()">Chiudi Viaggio</button>
      <button class="btn btn-primary btn-sm m-2" [disabled]="button_disabled_status_mapping.btn_riapri" (click)="onClick_btn_riapri()">Riapri Viaggio</button>
      <button class="btn btn-warning btn-sm m-2" [disabled]="button_disabled_status_mapping.btn_modKM" (click)="onClick_btn_modKM()">Modifica KM</button>
    </div>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-secondary" data-dismiss="modal"
            (click)="modalDismiss();modalRef.hide()">Annulla</button>
    <button type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            (click)="updateTravel()" [disabled]="buttonUpdateDisabled"> Modifica
    </button>

  </div>

</ng-template>

